import projectsConfig from './projects'
import projectsInspector from './projectsInspector'
import projectsRequestor from './projectsRequestor'
import usersConfig from './users'
import formsConfig from './forms'
import authorizationsConfig from './authorizations'
import ticketsConfig from './tickets'
import reportsConfig from './reports'
import projectNotificationsConfig from './projectNotifications'

const strategiesMap = {
  [projectsConfig.type]: projectsConfig,
  [ticketsConfig.type]: ticketsConfig,
  [projectsInspector.type]: projectsInspector,
  [projectsRequestor.type]: projectsRequestor,
  [usersConfig.type]: usersConfig,
  [formsConfig.type]: formsConfig,
  [authorizationsConfig.type]: authorizationsConfig,
  [reportsConfig.type]: reportsConfig,
  [projectNotificationsConfig.type]: projectNotificationsConfig,
  none: {},
}

export default strategiesMap
